import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '../views/auth.vue'
import DialogAuth from '../views/dialogAuth.vue'
import MobileAuth from '../views/mobileAuth.vue'
import DialogQRAuth from '../views/dialogQRAuth.vue'
import Register from '../views/register.vue'
import MobileRegister from '../views/mobileRegister.vue'
import forgotPassword from '../views/forgotPassword.vue'
import CallBack from '../views/callback.vue'
import DialogCallBack from '../views/dialogCallback.vue'
import DialogQRCallBack from '../views/dialogQRCallback.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/wxlogin'
  },
  {
    path: '/wxlogin',
    name: 'Auth',
    component: Auth
  },
  {
    path: '/mobilelogin',
    name: 'MobileAuth',
    component: MobileAuth
  },
  {
    path: '/dialoglogin',
    name: 'DialogAuth',
    component: DialogAuth
  },
  {
    path: '/dialogqrauth',
    name: 'DialogQRAuth',
    component: DialogQRAuth
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/mobileregister',
    name: 'MobileRegister',
    component: MobileRegister
  },
  {
    path: '/forgot_password',
    name: 'forgotPassword',
    component: forgotPassword
  },
  {
    path: '/callback',
    name: 'CallBack',
    component: CallBack
  },
  {
    path: '/dialogcallback',
    name: 'DialogCallBack',
    component: DialogCallBack
  },
  {
    path: '/dialogqrcallback',
    name: 'DialogQRCallBack',
    component: DialogQRCallBack
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
